import React from 'react';

const Parser = ({ onParse, file }) => {

	return (
		
			<input
				type='button'
				className='pointer f5 bn ba1 b--solid b--black pa3 bg-brand-magenta white grow'
				value="Read Export File"
				onClick={() => onParse(file)}
				/>
		)
}

export default Parser;